const setAddItemInComparator = (state, item) => {
  state.commit("SET_ADD_ITEM_IN_COMPARATOR", item)
}

const setRemoveItemFromComparator = (state, item) => {
  state.commit("SET_REMOVE_ITEM_FROM_COMPARATOR", item)
}

export default {
  setAddItemInComparator,
  setRemoveItemFromComparator
};
